import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import PageHeaderWithBreadcrumbs from "../components/common/PageHeaderWithBreadcrumbs.js";
import PageTitle from "../components/common/PageTitle";
import Space from "../components/common/Space.js";
import FAQSearch from "../components/common/FAQSearch.js";
import useFaqs from "../hooks/useFaqs.js";

const GetHelp = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("ETA-IL");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  // Récupérer les FAQ depuis l'API
  const { faqs: apiFaqs, loading: loadingFaqs } = useFaqs({ enableApi: true });
  
  // Fallback sur les données du fichier JSON si l'API échoue ou est vide
  const faqDataFromJson = t("getHelp.questionsSearch", { returnObjects: true });
  
  // Utiliser les FAQ de l'API si disponibles, sinon fallback sur JSON
  const faqData = (apiFaqs && apiFaqs.length > 0) ? apiFaqs : faqDataFromJson;
  
  //console.log('FAQ Source:', apiFaqs?.length > 0 ? 'API' : 'JSON', 'Count:', faqData?.length);
  return (
    <>
      <PageTitle pageKey="getHelp" titleKey="pageTitles.getHelp" fallbackTitle={t("pageTitles.getHelp")} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          background: "#E8EDF6",
          py: { xs: 2, md: 0 },
        }}
      >
        <PageHeaderWithBreadcrumbs
          breadcrumbs={[
            { text: t("getHelp.breadcrumbs.home"), href: "/" },
            { text: t("getHelp.breadcrumbs.application") },
          ]}
          title={t("getHelp.header.title")}
          subtitle={t("getHelp.header.subtitle")}
          applyButtonText={false}
          sticky={false}
        />
        <Container maxWidth="lg">
          {/* Onglets pour filtrer par catégorie */}
          <Box
            sx={{
              background: "transparent",
              borderRadius: "8px 8px 0 0",
              // boxShadow: "0 2px 16px rgba(24,59,86,0.07)",
              px: { xs: 0, sm: 0, md: 0 },
              pt: { xs: 2, sm: 2, md: 0 },
            }}
          >
            <Tabs
              value={activeTab}
              onChange={(event, newValue) => setActiveTab(newValue)}
              aria-label="Question by visa type"
              TabIndicatorProps={{
                style: {
                  height: 3,
                  backgroundColor: "#183B56",
                },
              }}
              sx={{
                // borderBottom: "1px solid #E0E0E0",
                "& .MuiTab-root": {
                  textTransform: "none",
                  borderRadius: "8px 8px 0 0",
                  fontWeight: 600,
                  fontSize: 16,
                  minHeight: 56,
                  px: 4,
                  color: "#183B56",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    color: "#183B56",
                    backgroundColor: "rgba(24, 59, 86, 0.04)",
                  },
                },
                "& .Mui-selected": {
                  color: "#183B56 !important",
                  backgroundColor: "#fff",
                },
              }}
            >
              <Tab label="ETA-IL" value="ETA-IL" />
              <Tab label="eVisa-B2" value="eVisa-B2" />
            </Tabs>
          </Box>
          
          {/* Indicateur de chargement */}
          {loadingFaqs && (
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              py: 4,
              background: '#fff',
              borderRadius: '0 8px 8px 8px'
            }}>
              <CircularProgress />
            </Box>
          )}
          
          {/* Bloc principal - FAQ */}
          {!loadingFaqs && (
            <FAQSearch questions={faqData} activeTab={activeTab} setActiveTab={setActiveTab} />
          )}
        </Container>
        <Space size="small" />
      </Box>
    </>
  );
};

export default GetHelp;
